import { styled } from '@mui/material';

const Main = styled('main')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  width: '100%',
  padding: theme.spacing(2),
  backgroundColor: '#F9FAFB',
}));

export default Main;
